/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/coins_3'
export default icon
